module.exports = __webpack_public_path__ + "img/grin-tongue.fabe2060.svg";